import { Login } from "../model/login";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { Component, OnInit, ViewChild } from "@angular/core";
import { AutenticacaoService } from "../../common/service/autenticacao.service";
import { UsuarioService } from "../../common/service/usuario.service";
import { CustomAlertService } from "../../common/service/custom-alert.service";
import { PermissoesUsuario } from "../../common/model/permissoes-usuario";
import { PermissaoDefault } from "../../common/model/permissao-default";
import { MatDialog } from "@angular/material/dialog";
import { AlterarSenhaComponent } from "../alterar-senha/alterar-senha.component";
import { environment } from "../../../../environments/environment";
import { ConfiguracaoService } from "../../common/service/configuracao.service";
import { mostrarSenha } from "../../common/utils/validacaoSenha";
import { WINDOW } from "../../../common/providers/window.provider";
import { Injectable, Inject } from '@angular/core';
import { LanguageService } from "../../common/service/language.service";
import { Credential, DuplaAutenticacaoTipo } from "../../autenticacao/model/credential";
import { StorageProxy } from "../../common/service/storage-proxy.service";
// Removed util import - using null check directly
import { Configuracao, ProvedorSSOCorporativo } from "../../common/model/configuracao";
import { ConfiguracaoAutenticacao } from "../model/configuracaoAutenticacao";
import { OtpInputComponent } from "../../../layout/otp-input/otp-input.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { isNull, isNullOrEmpty } from "../../common/utils";

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss", "../auth-shared.scss"],
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatButtonModule,
		MatCardModule,
		MatIconModule,
		MatTooltipModule,
		MatFormFieldModule,
		MatInputModule,
		MatMenuModule,
		RouterModule,
		TranslatePipe,
		OtpInputComponent
	],
	providers: [
		{ useClass: CustomAlertService, provide: CustomAlertService },
		{ useClass: UsuarioService, provide: UsuarioService },
		{ useClass: ConfiguracaoService, provide: ConfiguracaoService }
	]
})
export class LoginComponent implements OnInit {
	public login: Login;
	public AppConfig: any;
	public mostrarForm: boolean = false;
	public loginOktaAtivo: boolean = false;
	public loginAuthentikAtivo: boolean = false;
	configSSO: ConfiguracaoAutenticacao;
	idiomaSelecionado;
	idiomas;
	year: number = new Date().getFullYear();
	timeLeft: string = '00:00';
	CodigoInvalido: boolean = false;
	interval;
	duploFator: boolean = false;
	validarLogin: boolean = false;
	loginConfirmacao: Credential;

	hashContaPreenchida: boolean = false;


	logo: string = 'talkmaestria';

	constructor(
		private autenticacaoService: AutenticacaoService,
		private customAlertService: CustomAlertService,
		private usuarioService: UsuarioService,
		private configService: ConfiguracaoService,
		private router: Router,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private languageService: LanguageService,
		@Inject(WINDOW) private window: Window
	) {
		this.login = new Login();
		this.loginConfirmacao = new Credential();
		this.configSSO = new ConfiguracaoAutenticacao();
		this.idiomas = this.languageService.idiomas;
		this.idiomaSelecionado = this.languageService.getLanguage();


		if (this.window.location.hostname.includes('.teajudei'))
			this.logo = 'teajudei';

		if (this.window.location.hostname.includes('.epbx'))
			this.logo = 'talkmaestria';

		if (this.window.location.hostname.includes('.brbots'))
			this.logo = 'brbots';


	}

	ngOnInit() {
		this.AppConfig = environment;

		let preferenciasUsuario = PermissoesUsuario.preferenciasUsuario;

		if (!isNull(preferenciasUsuario)) {
			if (!isNullOrEmpty(preferenciasUsuario.hashContaLogin)) {
				this.login.hashConta = preferenciasUsuario.hashContaLogin;
				this.hashContaPreenchida = true;
			}
		}



		this.route.queryParams.subscribe(params => {
			if (params['logadoSSO']) {

				this.login.login = params['hash'];
				this.login.senha = params['hash'];

				this.VerificarCodigoLogin(DuplaAutenticacaoTipo.SSO);

			}

			if (!params['logado']) {
				this.checarAlteracaoSenha(params)
				this.mostrarForm = true;
				return;
			}

			this.autenticacaoService.obterCredenciaisPorCookie().subscribe(
				res => this.obterPermissoes(),
				error => {
					this.customAlertService.show(
						"Login",
						"login.autenticacaoFalhou",
						"error"
					);
				}
			);
		});
	}

	limparHashConta() {
		this.login.hashConta = '';
		this.hashContaPreenchida = false;

		let preferencias = PermissoesUsuario.preferenciasUsuario;
		preferencias.hashContaLogin = '';
		PermissoesUsuario.preferenciasUsuario = preferencias;
	}

	setLanguage(linguagem) {
		this.languageService.setLanguage(linguagem.codigo);
		this.idiomaSelecionado = linguagem;
		window.location.reload();
	}

	checarAlteracaoSenha(params) {
		if (params.key) {
			this.usuarioService.verificarChaveAlteracao(params.key).subscribe(s => {
				if (s.isValid) {
					this.login.login = s.data.login;
					let alterarSenhaRef = this.dialog.open(AlterarSenhaComponent, {
						disableClose: true,
						width: "420px",
						maxWidth: "95vw",
						maxHeight: "95vh",
						panelClass: "alterar-senha-dialog",
						data: {
							chave: params.key,
							data: s.data
						}
					});
				}
				else {
					this.customAlertService.show(
						"login.alteracaoSenha",
						"login.chaveAlteracaoInvalida",
						"error"
					);
				}
			}
			);
		}
	}

	get mostrarSenha() {
		return mostrarSenha;
	}

	recuperarSenha() {
		this.router.navigate(["/recuperarsenha"]);
	}

	realizarLogin() {
		if (isNullOrEmpty(this.login.hashConta) || isNullOrEmpty(this.login.login) || isNullOrEmpty(this.login.senha)) {
			return;
		}

		this.autenticacaoService.validarCredenciais(this.login).subscribe(
			credential => {
				this.loginConfirmacao = Object.assign(new Credential(), credential.data);

				this.configService.obterConfiguracoesAutenticacao().subscribe(config => {
					this.configSSO = config;

					if (this.loginConfirmacao.user) {
						StorageProxy.set('userData', this.loginConfirmacao);
						this.VerificarUsuarioCredencial(this.loginConfirmacao);
					}
					else {

						if (this.loginConfirmacao.duplaAutenticacaoTipo == DuplaAutenticacaoTipo.Desligada) {
							this.VerificarCodigoLogin(DuplaAutenticacaoTipo.Desligada);
						}
						else {

							if (this.loginConfirmacao.duplaAutenticacaoTipo == DuplaAutenticacaoTipo.Email)
								this.startTimer();

							this.duploFator = true;
							setTimeout(() => {
								this.otpInput.clear();
							});

						}
					}
				});
			},
			error => {
				localStorage.removeItem("userData");
				this.customAlertService.show(
					"Login",
					"login.usuarioOuSenhaInvalido",
					"error"
				);
			}
		);
	}

	VerificarUsuarioCredencial(credential: Credential) {
		if (credential.user.properties.status.toLowerCase() == "bloqueado") {
			localStorage.removeItem("userData");
			this.customAlertService.show(
				"Login",
				"login.usuarioBloqueado",
				"error"
			);
		}
		else if (credential.user.properties.status.toLowerCase() == "senhaexpirada") {
			localStorage.removeItem("userData");
			this.router.navigateByUrl(`/alterarsenhaexpirada?id=${credential.user.id}&p=1`);
		}
		else if (credential.user.properties.status.toLowerCase() == "primeiroacesso") {
			localStorage.removeItem("userData");
			this.router.navigateByUrl(`/alterarsenhaexpirada?id=${credential.user.id}&p=1`);
		}
		else {
			this.obterPermissoes();
		}
	}

	@ViewChild('otpInput') otpInput: OtpInputComponent;

	VerificarCodigoLogin(pDuplaAuntenticacaoTipo: DuplaAutenticacaoTipo) {
		this.login.duplaAutenticacaoTipo = pDuplaAuntenticacaoTipo;
		this.autenticacaoService.login(this.login).subscribe({
			complete: () => { },
			next: (credential) => {
				this.VerificarUsuarioCredencial(credential);
			},
			error: () => {
				if (pDuplaAuntenticacaoTipo == DuplaAutenticacaoTipo.SSO) {
					this.login.login = '';
					this.login.senha = '';
					this.customAlertService.show(
						"Login",
						"login.autenticacaoFalhou",
						"error"
					);
				}
				else {
					this.CodigoInvalido = true;
					this.otpInput.clear();
				}
			}
		});

	}

	ReenviarCodigo(tipoConfirmacao) {
		this.startTimer();
		this.loginConfirmacao.duplaAutenticacaoTipo = tipoConfirmacao;
		this.autenticacaoService.reenviarCodigo(this.login).subscribe({
			complete: () => { }
		});
	}

	onOtpChange(event) {
		this.login.codigo = event;
		if (this.login.codigo.length == this.loginConfirmacao.digitosDuplaAutenticacao)
			this.VerificarCodigoLogin(this.loginConfirmacao.duplaAutenticacaoTipo);
		else
			this.CodigoInvalido = false;
	}

	obterPermissoes() {
		this.autenticacaoService.obterPermissoes().subscribe(
			permissoes => {

				PermissoesUsuario.recursos = permissoes.permissaoRecurso;
				PermissoesUsuario.carteiras = permissoes.permissaoCarteira;
				PermissoesUsuario.listas = permissoes.permissaoLista;
				PermissoesUsuario.preferenciasUsuario = permissoes.preferenciasUsuario;
				return this.router.navigate([
					PermissaoDefault.obterRotaPadraoRedirecionamento()
				]);
			},
			error => {
				this.customAlertService.show(
					"Login",
					"login.autenticacaoFalhou",
					"error"
				);
			}
		);
	}


	startTimer() {


		let timer: number = this.configSSO.tempoVerificacao * 60;
		let minutes: any = 0;
		let seconds: any = 0;

		if (this.interval !== null) {
			clearInterval(this.interval);
		}

		this.timeLeft = '03:00';
		this.CodigoInvalido = false;

		this.interval = setInterval(() => {
			minutes = parseInt((timer / 60).toString(), 10);
			seconds = parseInt((timer % 60).toString(), 10);

			minutes = minutes < 10 ? "0" + minutes : minutes;
			seconds = seconds < 10 ? "0" + seconds : seconds;

			this.timeLeft = minutes + ":" + seconds;

			if (--timer < 0)
				clearInterval(this.interval);

		}, 1000);
	}

	loginSSO(codigo: string) {
		window.location.href = this.autenticacaoService.getAuthorizeSSOUrl(codigo);
	}
}
